import { create } from 'zustand'

/**
 * Simplified progress tracker store for UI display only
 * This store does not handle any upload/download logic - it only manages UI state
 */
export interface ProgressTrackerState {
  // UI state only
  uploadTracker: {
    isVisible: boolean
    isExpanded: boolean
  }
  downloadTracker: {
    isVisible: boolean
    isExpanded: boolean
  }

  // UI actions only
  setUploadVisible: (visible: boolean) => void
  setUploadExpanded: (expanded: boolean) => void
  toggleUploadExpanded: () => void

  setDownloadVisible: (visible: boolean) => void
  setDownloadExpanded: (expanded: boolean) => void
  toggleDownloadExpanded: () => void

  hideUploadTracker: () => void
  hideDownloadTracker: () => void

  reset: () => void
}

export const useProgressTrackerStore = create<ProgressTrackerState>(set => ({
  uploadTracker: {
    isVisible: false,
    isExpanded: true,
  },
  downloadTracker: {
    isVisible: false,
    isExpanded: true,
  },

  // Upload UI actions
  setUploadVisible: (visible: boolean) =>
    set(state => ({
      uploadTracker: { ...state.uploadTracker, isVisible: visible },
    })),

  setUploadExpanded: (expanded: boolean) =>
    set(state => ({
      uploadTracker: { ...state.uploadTracker, isExpanded: expanded },
    })),

  toggleUploadExpanded: () =>
    set(state => ({
      uploadTracker: { ...state.uploadTracker, isExpanded: !state.uploadTracker.isExpanded },
    })),

  // Download UI actions
  setDownloadVisible: (visible: boolean) =>
    set(state => ({
      downloadTracker: { ...state.downloadTracker, isVisible: visible },
    })),

  setDownloadExpanded: (expanded: boolean) =>
    set(state => ({
      downloadTracker: { ...state.downloadTracker, isExpanded: expanded },
    })),

  toggleDownloadExpanded: () =>
    set(state => ({
      downloadTracker: { ...state.downloadTracker, isExpanded: !state.downloadTracker.isExpanded },
    })),

  // Close actions
  hideUploadTracker: () =>
    set(state => ({
      uploadTracker: { ...state.uploadTracker, isVisible: false },
    })),

  hideDownloadTracker: () =>
    set(state => ({
      downloadTracker: { ...state.downloadTracker, isVisible: false },
    })),

  // Reset to initial state
  reset: () =>
    set({
      uploadTracker: {
        isVisible: false,
        isExpanded: true,
      },
      downloadTracker: {
        isVisible: false,
        isExpanded: true,
      },
    }),
}))
